<template>
	<janela-de-notificacao
		:exibir="exibir"
		:titulo-notificacao="`teste assinaturas concluídas`"
		notificacao-com-botao
		:largura-maxima="300"
		@close="$emit('fechar-modal')"
		@minimizar-janela="tratarEventoMinimizarJanela"
	>
		<template #contentBody>
			<modal
				:exibir="exibirModal"
				:titulo="`${tituloModal}`"
				:maxWidth="500"
				@close="tratarEventoMinimizarJanela"
			>
				<template #body>
					<div class="btn-recarregar btn-recarregar__template-vazio" v-if="!hasItens">
						<botao-tooltip
							icone="mdi-reload"
							cor="grey"
							texto="Atualizar assinaturas não concluídas"
							@click="$emit('atualizar')"
						></botao-tooltip>
					</div>
					<v-row dense class="az-form-content cp-modal-form-content" v-if="hasItens">
						<v-col cols="12" class="pb-0 btn-recarregar btn-recarregar__has-itens">
							<botao-tooltip
								icone="mdi-reload"
								cor="grey"
								texto="Atualizar assinaturas não concluídas"
								@click="$emit('atualizar')"
							></botao-tooltip>
						</v-col>
						<v-col cols="12" clas="pb-0">
							<v-list>
								<v-list-item v-for="(documento, index) in documentos" :key="index">
									<v-list-item-action
										v-if="ehAssinaturaDocumentoErro(documento)"
										id="caixaDeSelecao"
										class="mr-0"
									>
										<v-checkbox v-model="documentosSelecionados" :value="documento"></v-checkbox>
									</v-list-item-action>

									<v-list-item-content>
										<span>{{ documento.tituloDocumento }}</span>
									</v-list-item-content>

									<v-list-item-action-text>
										<div>
											<v-tooltip top>
												<template #activator="{ on, attrs }">
													<v-icon
														v-bind="attrs"
														size="20"
														:color="getCorSituacaoAssinatura(documento)"
														v-on="on"
													>
														{{ getIconeSituacaoAssinatura(documento) }}
													</v-icon>
												</template>
												<span>{{ getMensagemInformativaAssinaturaDocumento(documento) }}</span>
											</v-tooltip>

											<v-tooltip v-if="ehAssinaturaDocumentoErro(documento)" top>
												<template #activator="{ on, attrs }">
													<v-btn
														id="iconeAssinarDocumento"
														class="ml-2"
														icon
														v-bind="attrs"
														v-on="on"
														@click="assinarIndividualmenteDocumento(documento)"
													>
														<v-icon size="20" color="primary">mdi-draw-pen</v-icon>
													</v-btn>
												</template>
												<span>Assinar Individualmente</span>
											</v-tooltip>
										</div>
									</v-list-item-action-text>
								</v-list-item>
							</v-list>
						</v-col>
					</v-row>
					<v-row v-if="!hasItens">
						<v-col cols="12" clas="pb-0">
							<template-listagem-vazia
								:textos="textosTemplateListagemVazia"
								:total-itens="documentos.length"
							>
							</template-listagem-vazia>
						</v-col>
					</v-row>
				</template>
				<template #actions>
					<v-divider></v-divider>
					<v-card-actions class="pb-3 pt-3">
						<v-row no-gutters>
							<botao-cancelar @cancelar="tratarEventoMinimizarJanela"></botao-cancelar>
							<botao-primario
								nomeBotao="Assinar"
								class="ml-auto"
								@click="assinarEmLoteDocumentos"
								:disabled="naoTemDocumentosSelecionados"
							></botao-primario>
						</v-row>
					</v-card-actions>
				</template>
			</modal>
		</template>
	</janela-de-notificacao>
</template>

<script>
import { situacaoAssinaturaDocumentoLote } from '@/core/constants'
import Modal from '@/views/components/Modal.vue'
import JanelaDeNotificacao from '@/views/components/JanelaDeNotificacao.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'

export default {
	name: 'modal-assinatura-progresso-lote',
	components: { BotaoPrimario, JanelaDeNotificacao, Modal },
	props: {
		exibir: {
			type: Boolean,
		},
		documentos: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			exibirModal: false,
			tituloModal: 'Assinaturas não concluídas',
			documentosSelecionados: [],
			textosTemplateListagemVazia: {
				titulo: 'Você não possui nenhuma assinatura pendente',
			},
		}
	},
	computed: {
		naoTemDocumentosSelecionados() {
			return this.documentosSelecionados.length <= 0
		},
		temApenasUmDocumentoSelecionado() {
			return this.documentosSelecionados.length === 1
		},
		hasItens() {
			return this.documentos.length > 0
		},
	},
	methods: {
		assinarEmLoteDocumentos() {
			if (this.naoTemDocumentosSelecionados) {
				this.mostrarNotificacaoErro('Deve ser selecionado ao menos 1 documento')
				return
			}

			if (this.temApenasUmDocumentoSelecionado) {
				this.assinarIndividualmenteDocumento(this.documentosSelecionados)
				this.documentosSelecionados = []
				return
			}

			this.tratarEventoMinimizarJanela()
			this.$emit('assinar-eletronicamente-documento-lote', this.documentosSelecionados)
			this.documentosSelecionados = []
		},
		assinarIndividualmenteDocumento(documento) {
			this.tratarEventoMinimizarJanela()
			this.$emit('assinar-individualmente-documento', documento)
		},
		getCorSituacaoAssinatura(documento) {
			switch (documento.situacao) {
				case situacaoAssinaturaDocumentoLote.EM_PROCESSAMENTO.value:
					return 'warning'
				case situacaoAssinaturaDocumentoLote.ERRO.value:
					return 'error'

				default:
					return ''
			}
		},
		getMensagemInformativaAssinaturaDocumento(documento) {
			switch (documento.situacao) {
				case situacaoAssinaturaDocumentoLote.EM_PROCESSAMENTO.value:
					return `Assinatura em processamento`
				case situacaoAssinaturaDocumentoLote.ERRO.value:
					return `Ocorreu um erro no processamento da assinatura`
				default:
					return ''
			}
		},
		getIconeSituacaoAssinatura(documento) {
			switch (documento.situacao) {
				case situacaoAssinaturaDocumentoLote.EM_PROCESSAMENTO.value:
					return 'mdi-clock-outline'
				case situacaoAssinaturaDocumentoLote.ERRO.value:
					return 'mdi-alert-octagon-outline'
				default:
					return ''
			}
		},
		ehAssinaturaDocumentoErro(documento) {
			return documento.situacao === situacaoAssinaturaDocumentoLote.ERRO.value
		},
		tratarEventoMinimizarJanela() {
			this.exibirModal = !this.exibirModal
		},
	},
}
</script>

<style lang="stylus" scoped>
.btn-recarregar
  text-align: end;
  position: relative;

  &__template-vazio
    top 5px !important
    left 15px !important

  &__has-itens
    left: 40px;
    bottom: 15px;

.v-list
	list-style-type none
	margin 0 !important
	padding 0 !important

	.v-list-item
		padding 0 !important
		border-bottom 1px solid #ebebeb
		font-size 14px
		color #434343

		.v-list-item__content > :not(:last-child)
			margin-bottom 0 !important
</style>
